"use client";
import { createMinimalMotionComponent } from "./create";
/**
 * HTML components
 */
export const MotionA = /*@__PURE__*/ createMinimalMotionComponent("a");
export const MotionAbbr = /*@__PURE__*/ createMinimalMotionComponent("abbr");
export const MotionAddress = 
/*@__PURE__*/ createMinimalMotionComponent("address");
export const MotionArea = /*@__PURE__*/ createMinimalMotionComponent("area");
export const MotionArticle = 
/*@__PURE__*/ createMinimalMotionComponent("article");
export const MotionAside = /*@__PURE__*/ createMinimalMotionComponent("aside");
export const MotionAudio = /*@__PURE__*/ createMinimalMotionComponent("audio");
export const MotionB = /*@__PURE__*/ createMinimalMotionComponent("b");
export const MotionBase = /*@__PURE__*/ createMinimalMotionComponent("base");
export const MotionBdi = /*@__PURE__*/ createMinimalMotionComponent("bdi");
export const MotionBdo = /*@__PURE__*/ createMinimalMotionComponent("bdo");
export const MotionBig = /*@__PURE__*/ createMinimalMotionComponent("big");
export const MotionBlockquote = 
/*@__PURE__*/ createMinimalMotionComponent("blockquote");
export const MotionBody = /*@__PURE__*/ createMinimalMotionComponent("body");
export const MotionButton = /*@__PURE__*/ createMinimalMotionComponent("button");
export const MotionCanvas = /*@__PURE__*/ createMinimalMotionComponent("canvas");
export const MotionCaption = 
/*@__PURE__*/ createMinimalMotionComponent("caption");
export const MotionCite = /*@__PURE__*/ createMinimalMotionComponent("cite");
export const MotionCode = /*@__PURE__*/ createMinimalMotionComponent("code");
export const MotionCol = /*@__PURE__*/ createMinimalMotionComponent("col");
export const MotionColgroup = 
/*@__PURE__*/ createMinimalMotionComponent("colgroup");
export const MotionData = /*@__PURE__*/ createMinimalMotionComponent("data");
export const MotionDatalist = 
/*@__PURE__*/ createMinimalMotionComponent("datalist");
export const MotionDd = /*@__PURE__*/ createMinimalMotionComponent("dd");
export const MotionDel = /*@__PURE__*/ createMinimalMotionComponent("del");
export const MotionDetails = 
/*@__PURE__*/ createMinimalMotionComponent("details");
export const MotionDfn = /*@__PURE__*/ createMinimalMotionComponent("dfn");
export const MotionDialog = /*@__PURE__*/ createMinimalMotionComponent("dialog");
export const MotionDiv = /*@__PURE__*/ createMinimalMotionComponent("div");
export const MotionDl = /*@__PURE__*/ createMinimalMotionComponent("dl");
export const MotionDt = /*@__PURE__*/ createMinimalMotionComponent("dt");
export const MotionEm = /*@__PURE__*/ createMinimalMotionComponent("em");
export const MotionEmbed = /*@__PURE__*/ createMinimalMotionComponent("embed");
export const MotionFieldset = 
/*@__PURE__*/ createMinimalMotionComponent("fieldset");
export const MotionFigcaption = 
/*@__PURE__*/ createMinimalMotionComponent("figcaption");
export const MotionFigure = /*@__PURE__*/ createMinimalMotionComponent("figure");
export const MotionFooter = /*@__PURE__*/ createMinimalMotionComponent("footer");
export const MotionForm = /*@__PURE__*/ createMinimalMotionComponent("form");
export const MotionH1 = /*@__PURE__*/ createMinimalMotionComponent("h1");
export const MotionH2 = /*@__PURE__*/ createMinimalMotionComponent("h2");
export const MotionH3 = /*@__PURE__*/ createMinimalMotionComponent("h3");
export const MotionH4 = /*@__PURE__*/ createMinimalMotionComponent("h4");
export const MotionH5 = /*@__PURE__*/ createMinimalMotionComponent("h5");
export const MotionH6 = /*@__PURE__*/ createMinimalMotionComponent("h6");
export const MotionHead = /*@__PURE__*/ createMinimalMotionComponent("head");
export const MotionHeader = /*@__PURE__*/ createMinimalMotionComponent("header");
export const MotionHgroup = /*@__PURE__*/ createMinimalMotionComponent("hgroup");
export const MotionHr = /*@__PURE__*/ createMinimalMotionComponent("hr");
export const MotionHtml = /*@__PURE__*/ createMinimalMotionComponent("html");
export const MotionI = /*@__PURE__*/ createMinimalMotionComponent("i");
export const MotionIframe = /*@__PURE__*/ createMinimalMotionComponent("iframe");
export const MotionImg = /*@__PURE__*/ createMinimalMotionComponent("img");
export const MotionInput = /*@__PURE__*/ createMinimalMotionComponent("input");
export const MotionIns = /*@__PURE__*/ createMinimalMotionComponent("ins");
export const MotionKbd = /*@__PURE__*/ createMinimalMotionComponent("kbd");
export const MotionKeygen = /*@__PURE__*/ createMinimalMotionComponent("keygen");
export const MotionLabel = /*@__PURE__*/ createMinimalMotionComponent("label");
export const MotionLegend = /*@__PURE__*/ createMinimalMotionComponent("legend");
export const MotionLi = /*@__PURE__*/ createMinimalMotionComponent("li");
export const MotionLink = /*@__PURE__*/ createMinimalMotionComponent("link");
export const MotionMain = /*@__PURE__*/ createMinimalMotionComponent("main");
export const MotionMap = /*@__PURE__*/ createMinimalMotionComponent("map");
export const MotionMark = /*@__PURE__*/ createMinimalMotionComponent("mark");
export const MotionMenu = /*@__PURE__*/ createMinimalMotionComponent("menu");
export const MotionMenuitem = 
/*@__PURE__*/ createMinimalMotionComponent("menuitem");
export const MotionMeter = /*@__PURE__*/ createMinimalMotionComponent("meter");
export const MotionNav = /*@__PURE__*/ createMinimalMotionComponent("nav");
export const MotionObject = /*@__PURE__*/ createMinimalMotionComponent("object");
export const MotionOl = /*@__PURE__*/ createMinimalMotionComponent("ol");
export const MotionOptgroup = 
/*@__PURE__*/ createMinimalMotionComponent("optgroup");
export const MotionOption = /*@__PURE__*/ createMinimalMotionComponent("option");
export const MotionOutput = /*@__PURE__*/ createMinimalMotionComponent("output");
export const MotionP = /*@__PURE__*/ createMinimalMotionComponent("p");
export const MotionParam = /*@__PURE__*/ createMinimalMotionComponent("param");
export const MotionPicture = 
/*@__PURE__*/ createMinimalMotionComponent("picture");
export const MotionPre = /*@__PURE__*/ createMinimalMotionComponent("pre");
export const MotionProgress = 
/*@__PURE__*/ createMinimalMotionComponent("progress");
export const MotionQ = /*@__PURE__*/ createMinimalMotionComponent("q");
export const MotionRp = /*@__PURE__*/ createMinimalMotionComponent("rp");
export const MotionRt = /*@__PURE__*/ createMinimalMotionComponent("rt");
export const MotionRuby = /*@__PURE__*/ createMinimalMotionComponent("ruby");
export const MotionS = /*@__PURE__*/ createMinimalMotionComponent("s");
export const MotionSamp = /*@__PURE__*/ createMinimalMotionComponent("samp");
export const MotionScript = /*@__PURE__*/ createMinimalMotionComponent("script");
export const MotionSection = 
/*@__PURE__*/ createMinimalMotionComponent("section");
export const MotionSelect = /*@__PURE__*/ createMinimalMotionComponent("select");
export const MotionSmall = /*@__PURE__*/ createMinimalMotionComponent("small");
export const MotionSource = /*@__PURE__*/ createMinimalMotionComponent("source");
export const MotionSpan = /*@__PURE__*/ createMinimalMotionComponent("span");
export const MotionStrong = /*@__PURE__*/ createMinimalMotionComponent("strong");
export const MotionStyle = /*@__PURE__*/ createMinimalMotionComponent("style");
export const MotionSub = /*@__PURE__*/ createMinimalMotionComponent("sub");
export const MotionSummary = 
/*@__PURE__*/ createMinimalMotionComponent("summary");
export const MotionSup = /*@__PURE__*/ createMinimalMotionComponent("sup");
export const MotionTable = /*@__PURE__*/ createMinimalMotionComponent("table");
export const MotionTbody = /*@__PURE__*/ createMinimalMotionComponent("tbody");
export const MotionTd = /*@__PURE__*/ createMinimalMotionComponent("td");
export const MotionTextarea = 
/*@__PURE__*/ createMinimalMotionComponent("textarea");
export const MotionTfoot = /*@__PURE__*/ createMinimalMotionComponent("tfoot");
export const MotionTh = /*@__PURE__*/ createMinimalMotionComponent("th");
export const MotionThead = /*@__PURE__*/ createMinimalMotionComponent("thead");
export const MotionTime = /*@__PURE__*/ createMinimalMotionComponent("time");
export const MotionTitle = /*@__PURE__*/ createMinimalMotionComponent("title");
export const MotionTr = /*@__PURE__*/ createMinimalMotionComponent("tr");
export const MotionTrack = /*@__PURE__*/ createMinimalMotionComponent("track");
export const MotionU = /*@__PURE__*/ createMinimalMotionComponent("u");
export const MotionUl = /*@__PURE__*/ createMinimalMotionComponent("ul");
export const MotionVideo = /*@__PURE__*/ createMinimalMotionComponent("video");
export const MotionWbr = /*@__PURE__*/ createMinimalMotionComponent("wbr");
export const MotionWebview = 
/*@__PURE__*/ createMinimalMotionComponent("webview");
/**
 * SVG components
 */
export const MotionAnimate = 
/*@__PURE__*/ createMinimalMotionComponent("animate");
export const MotionCircle = /*@__PURE__*/ createMinimalMotionComponent("circle");
export const MotionDefs = /*@__PURE__*/ createMinimalMotionComponent("defs");
export const MotionDesc = /*@__PURE__*/ createMinimalMotionComponent("desc");
export const MotionEllipse = 
/*@__PURE__*/ createMinimalMotionComponent("ellipse");
export const MotionG = /*@__PURE__*/ createMinimalMotionComponent("g");
export const MotionImage = /*@__PURE__*/ createMinimalMotionComponent("image");
export const MotionLine = /*@__PURE__*/ createMinimalMotionComponent("line");
export const MotionFilter = /*@__PURE__*/ createMinimalMotionComponent("filter");
export const MotionMarker = /*@__PURE__*/ createMinimalMotionComponent("marker");
export const MotionMask = /*@__PURE__*/ createMinimalMotionComponent("mask");
export const MotionMetadata = 
/*@__PURE__*/ createMinimalMotionComponent("metadata");
export const MotionPath = /*@__PURE__*/ createMinimalMotionComponent("path");
export const MotionPattern = 
/*@__PURE__*/ createMinimalMotionComponent("pattern");
export const MotionPolygon = 
/*@__PURE__*/ createMinimalMotionComponent("polygon");
export const MotionPolyline = 
/*@__PURE__*/ createMinimalMotionComponent("polyline");
export const MotionRect = /*@__PURE__*/ createMinimalMotionComponent("rect");
export const MotionStop = /*@__PURE__*/ createMinimalMotionComponent("stop");
export const MotionSvg = /*@__PURE__*/ createMinimalMotionComponent("svg");
export const MotionSymbol = /*@__PURE__*/ createMinimalMotionComponent("symbol");
export const MotionText = /*@__PURE__*/ createMinimalMotionComponent("text");
export const MotionTspan = /*@__PURE__*/ createMinimalMotionComponent("tspan");
export const MotionUse = /*@__PURE__*/ createMinimalMotionComponent("use");
export const MotionView = /*@__PURE__*/ createMinimalMotionComponent("view");
export const MotionClipPath = 
/*@__PURE__*/ createMinimalMotionComponent("clipPath");
export const MotionFeBlend = 
/*@__PURE__*/ createMinimalMotionComponent("feBlend");
export const MotionFeColorMatrix = 
/*@__PURE__*/ createMinimalMotionComponent("feColorMatrix");
export const MotionFeComponentTransfer = 
/*@__PURE__*/ createMinimalMotionComponent("feComponentTransfer");
export const MotionFeComposite = 
/*@__PURE__*/ createMinimalMotionComponent("feComposite");
export const MotionFeConvolveMatrix = 
/*@__PURE__*/ createMinimalMotionComponent("feConvolveMatrix");
export const MotionFeDiffuseLighting = 
/*@__PURE__*/ createMinimalMotionComponent("feDiffuseLighting");
export const MotionFeDisplacementMap = 
/*@__PURE__*/ createMinimalMotionComponent("feDisplacementMap");
export const MotionFeDistantLight = 
/*@__PURE__*/ createMinimalMotionComponent("feDistantLight");
export const MotionFeDropShadow = 
/*@__PURE__*/ createMinimalMotionComponent("feDropShadow");
export const MotionFeFlood = 
/*@__PURE__*/ createMinimalMotionComponent("feFlood");
export const MotionFeFuncA = 
/*@__PURE__*/ createMinimalMotionComponent("feFuncA");
export const MotionFeFuncB = 
/*@__PURE__*/ createMinimalMotionComponent("feFuncB");
export const MotionFeFuncG = 
/*@__PURE__*/ createMinimalMotionComponent("feFuncG");
export const MotionFeFuncR = 
/*@__PURE__*/ createMinimalMotionComponent("feFuncR");
export const MotionFeGaussianBlur = 
/*@__PURE__*/ createMinimalMotionComponent("feGaussianBlur");
export const MotionFeImage = 
/*@__PURE__*/ createMinimalMotionComponent("feImage");
export const MotionFeMerge = 
/*@__PURE__*/ createMinimalMotionComponent("feMerge");
export const MotionFeMergeNode = 
/*@__PURE__*/ createMinimalMotionComponent("feMergeNode");
export const MotionFeMorphology = 
/*@__PURE__*/ createMinimalMotionComponent("feMorphology");
export const MotionFeOffset = 
/*@__PURE__*/ createMinimalMotionComponent("feOffset");
export const MotionFePointLight = 
/*@__PURE__*/ createMinimalMotionComponent("fePointLight");
export const MotionFeSpecularLighting = 
/*@__PURE__*/ createMinimalMotionComponent("feSpecularLighting");
export const MotionFeSpotLight = 
/*@__PURE__*/ createMinimalMotionComponent("feSpotLight");
export const MotionFeTile = /*@__PURE__*/ createMinimalMotionComponent("feTile");
export const MotionFeTurbulence = 
/*@__PURE__*/ createMinimalMotionComponent("feTurbulence");
export const MotionForeignObject = 
/*@__PURE__*/ createMinimalMotionComponent("foreignObject");
export const MotionLinearGradient = 
/*@__PURE__*/ createMinimalMotionComponent("linearGradient");
export const MotionRadialGradient = 
/*@__PURE__*/ createMinimalMotionComponent("radialGradient");
export const MotionTextPath = 
/*@__PURE__*/ createMinimalMotionComponent("textPath");
//# sourceMappingURL=elements.js.map